import { useEffect } from 'react';

export function usePreventScroll(active: boolean) {
    useEffect(() => {
        if (!active) return;

        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, [active]);
}
